<template>
  <v-row no-gutters>
    <v-col
      md="8"
      cols="12"
      class="register-hero"
      pb-3
    >
      <v-layout justify-center align-center>
        <v-flex shrink>
          <v-img contain
                 min-width="100"
                 src="@/assets/logo.svg"
                 width="300"/>
        </v-flex>
      </v-layout>
      <v-layout class="claims-text-container" justify-center align-center>
        <v-flex pb-6 shrink>
          <h2>{{ $t('REGISTER.REGISTER_1') }}</h2>
          <h3>{{ $t('REGISTER.REGISTER_2') }}</h3>
          <h4>{{ $t('REGISTER.REGISTER_3') }}</h4>
          <h4>{{ $t('REGISTER.REGISTER_4') }}</h4>
          <h3>{{ $t('REGISTER.REGISTER_5') }}</h3>
        </v-flex>
      </v-layout>
    </v-col>

    <v-col
      md="4"
      cols="12"
      class="px-4 py-10"
    >
      <div
        v-if="$store.state.session.isLoading"
        class="my-12"
      >
        <BaseLoader />
      </div>
      <form>
        <h2>{{ $t('REGISTER.TITLE') }}</h2>
        <p>{{ $t('REGISTER.DESCRIPTION') }}</p>
        <p>
          <v-text-field
            v-model="user"
            :rules="[rules.required]"
            type="text"
            name="username"
            :label="$t('REGISTER.USERNAME')"
            class="input-group--focused"
          ></v-text-field>
        </p>
        <p>
          <v-text-field
            v-model="pass"
            :append-icon="show ? 'visibility_off' : 'visibility'"
            :rules="[rules.required, rules.min]"
            :type="show ? 'text' : 'password'"
            name="password"
            :label="$t('REGISTER.PASSWORD')"
            :hint="$t('REGISTER.PASS_HINT')"
            class="input-group--focused"
            @click:append="show = !show"
          ></v-text-field>
        </p>

        <YearSelector
          :year="$store.state.settings.year"
          ref="yearSelect"
        />

        <v-row class="align-center register-row pr-4 pb-4" no-gutters>
          <v-col cols="auto">
            <v-checkbox v-model="agree" />
          </v-col>
          <v-col cols="auto">
            {{ $t('REGISTER.I_HAVE_READ') }}
            <router-link
              to="/privacy"
              target="_blank"
            >
              <span @click="$track('privacy', 'auth')">
                {{ $t('PRIVACY_POLICY') }}
              </span>
            </router-link>
            {{ $t('REGISTER.AND') }}
            <router-link
              to="/tos"
              target="_blank"
            >
              <span @click="$track('terms', 'auth')">
                {{ $t('TERMS_OF_SERVICE') }}
              </span>
            </router-link>
          </v-col>
        </v-row>

        <div v-if="showAgeError" class="text-center pb-4">
          <h3>{{ $t('YEAR_CHECK.FORBIDDEN.TITLE') }}</h3>
          <p class="my-2">
            {{ $t('YEAR_CHECK.FORBIDDEN.SUBTITLE') }}
          </p>
        </div>

        <BaseButton
          :disabled="isButtonDisabled || showAgeError"
          @click="register()"
        >
          {{ $t('REGISTER.SUBMIT') }}
        </BaseButton>

        <p class="text-center mt-4">
          <router-link to="login">
            {{ $t('REGISTER.LOGIN') }}
          </router-link>
        </p>
          <p class="text-center my-4">
            <router-link to="home">
              {{ $t('PLAY_ANONYMOUSLY') }}
            </router-link>
          </p>
      </form>
    </v-col>
  </v-row>
</template>

<style scoped>
.register-hero {
  background-color: #ffeaef;
  background-image: url('../assets/img/banner-left.png');
  background-size: 50%;
  background-position: 0% 100%;
}

@media screen and (max-height: 960px) {
  .register-hero {
    background-size: 18%;
  }
}

@media screen and (max-width: 960px) {
  .register-hero {
    background-image: url('../assets/img/monigotes/1_opacity.png'),
                      url('../assets/img/monigotes/2_opacity.png'),
                      url('../assets/img/monigotes/3_opacity.png');
    background-size: 20%, 21%, 22%;
    background-position: 44% 85%, 20% 68%, 70% 75%;
  }
}

.register-row {
  flex-wrap: nowrap;
}

.claims-text-container{
  max-width: 80%;
  width: 80%;
  margin: 0 auto;
}

.claims-text-container h3, .claims-text-container h4{
  margin-top: 1rem;
}
</style>

<script>
// import GenericLayout from '@/layouts/GenericLayout.vue';
import YearSelector from '@/components/YearSelector.vue';

export default {
  name: 'Register',
  components: {
    // GenericLayout,
    YearSelector,
  },
  data: () => ({
    user: '',
    pass: '',
    agree: false,
    show: false,
    showAgeError: false,
  }),
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t('REGISTER.ERROR_FIELD_MANDATORY'),
        min: (v) => v.length >= 8 || this.$t('REGISTER.ERROR_PASSWORD_SHORT'),
      };
    },
    isButtonDisabled() {
      let year = this.$refs.yearSelect && this.$refs.yearSelect.date;
      if (year) {
        year = `${year}`;
      }

      return (this.$refs.yearSelect && !this.$refs.yearSelect.date)
        || (year && year.length !== 4)
        || !this.agree
        || !this.user
        || !this.validPass;
    },
    validPass() {
      return this.pass && this.pass.length >= 8;
    },
  },
  methods: {
    register() {
      const canPlay = this.$refs.yearSelect.check();
      if (!canPlay) {
        this.showAgeError = true;
        return false;
      }

      if (!this.agree) {
        return false;
      }

      return this.$store.dispatch('session/register', {
        name: this.user,
        pass: this.pass,
        year: this.$refs.yearSelect.date,
        agree: new Date(),
      })
        .then(() => {
          this.$track('sign_up', 'auth');
          this.$router.replace({ name: 'home' });
        })
        .catch((e) => {
          const alert = {
            color: 'red',
            text: this.$t('REGISTER.ERROR_GENERIC'),
          };

          if (e && e.code === 'auth/email-already-in-use') {
            alert.text = this.$t('REGISTER.ERROR_NAME_TAKEN');
          }

          this.$store.dispatch('alerts/show', alert);
        });
    },
  },
  created() {
    // if (this.$store.state.session.isLogged) {
    if (!this.$store.state.session.isAnonymous) {
      this.$router.replace({ name: 'home' });
    }
  },
};
</script>
